export interface PaletteEntry {
  name: string;
  utility: string;
  hexLight: string;
  hexDark: string;
}

export const SURFACES: PaletteEntry[] = [
  {
    name: "page",
    utility: "bg-page",
    hexLight: "#F4EFED",
    hexDark: "#181D25",
  },
  {
    name: "surface",
    utility: "bg-surface",
    hexLight: "#F2EDE6",
    hexDark: "#1E252F",
  },
  {
    name: "hairline",
    utility: "border-hairline",
    hexLight: "#E8E0D6",
    hexDark: "#2B3442",
  },
];

export const TEXT: PaletteEntry[] = [
  {
    name: "ink-body",
    utility: "text-ink-body",
    hexLight: "#2C2C2C",
    hexDark: "#C9D2DC",
  },
  {
    name: "ink-display",
    utility: "text-ink-display",
    hexLight: "#2C2C2C",
    hexDark: "#EDF1F6",
  },
  {
    name: "ink-muted",
    utility: "text-ink-muted",
    hexLight: "#6B7B7D",
    hexDark: "#B4CABA",
  },
];

export const SPLASH: PaletteEntry[] = [
  {
    name: "accent",
    utility: "bg-accent / text-accent",
    hexLight: "#5F7493",
    hexDark: "#869BBE",
  },
  {
    name: "accent-faded",
    utility: "bg-accent-faded",
    hexLight: "#EFF1F4",
    hexDark: "#1B2330",
  },
  {
    name: "accent-display",
    utility: "bg-accent-display / text-accent-display",
    hexLight: "#5F7493",
    hexDark: "#ADC2EA",
  },
  {
    name: "signal",
    utility: "bg-signal / text-signal",
    hexLight: "#fcd34d",
    hexDark: "#fcd34d",
  },
  {
    name: "signal-faded",
    utility: "bg-signal-faded",
    hexLight: "#fffaea",
    hexDark: "#2f2b21",
  },
  {
    name: "signal-display",
    utility: "bg-signal-display / text-signal-display",
    hexLight: "oklch(76% 0.165 82)",
    hexDark: "oklch(93% 0.13 95)",
  },
  {
    name: "danger",
    utility: "bg-danger / text-danger",
    hexLight: "oklch(64% 0.22 25)",
    hexDark: "oklch(72% 0.20 22)",
  },
  {
    name: "danger-faded",
    utility: "bg-danger-faded",
    hexLight: "oklch(96% 0.025 25)",
    hexDark: "oklch(22% 0.05 22)",
  },
  {
    name: "danger-display",
    utility: "bg-danger-display / text-danger-display",
    hexLight: "oklch(55% 0.20 25)",
    hexDark: "oklch(82% 0.18 22)",
  },
];

export const SANCTUARY_BRAND: PaletteEntry[] = [
  { name: "navy",            utility: "bg-navy / text-navy (alias: teal)",           hexLight: "#5F7493", hexDark: "#5F7493" },
  { name: "navy-mid",        utility: "bg-navy-mid / text-navy-mid (alias: teal-mid)", hexLight: "#869BBE", hexDark: "#869BBE" },
  { name: "navy-light",      utility: "bg-navy-light / text-navy-light (alias: teal-light)", hexLight: "#ADC2EA", hexDark: "#ADC2EA" },
  { name: "navy-deep",       utility: "bg-navy-deep / text-navy-deep",         hexLight: "#081534", hexDark: "#081534" },
  { name: "sage",            utility: "bg-sage / text-sage",                   hexLight: "#B4CABA", hexDark: "#B4CABA" },
  { name: "sage-light",      utility: "bg-sage-light / text-sage-light",       hexLight: "#D2DFD6", hexDark: "#D2DFD6" },
  { name: "stone",           utility: "bg-stone / text-stone",                 hexLight: "#F2EDE6", hexDark: "#F2EDE6" },
  { name: "stone-mid",       utility: "bg-stone-mid / text-stone-mid",         hexLight: "#E8E0D6", hexDark: "#E8E0D6" },
  { name: "cream",           utility: "bg-cream / text-cream",                 hexLight: "#F4EFED", hexDark: "#F4EFED" },
  { name: "brand-text",      utility: "text-brand-text",                       hexLight: "#2C2C2C", hexDark: "#2C2C2C" },
  { name: "brand-text-muted",utility: "text-brand-text-muted",                 hexLight: "#6B7B7D", hexDark: "#6B7B7D" },
];

// The logo *file's* own colors — brighter/more saturated than the site's
// softened navy (see docs/brand-colours.md §4). Reference only: for
// recreating the literal mark (an inline SVG, a favicon), not general UI —
// prefer the SANCTUARY_BRAND navy tokens above for everything else.
export const LOGO_COLORS: PaletteEntry[] = [
  { name: "logo-navy",      utility: "bg-logo-navy / text-logo-navy",           hexLight: "#2B4A9A", hexDark: "#2B4A9A" },
  { name: "logo-navy-dark", utility: "bg-logo-navy-dark / text-logo-navy-dark", hexLight: "#1E3A5F", hexDark: "#1E3A5F" },
  { name: "logo-sky",       utility: "bg-logo-sky / text-logo-sky",             hexLight: "#98B5D3", hexDark: "#98B5D3" },
];

export const FONTS = {
  display: "Cormorant Garamond",
  body: "Inter",
};
